import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import GlobalStyle from './styles/globals';

import Routes from './routes';

import AppProvider from './hooks';
import Header from './components/Header';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <Router>
      <AppProvider>
        <Header />
        <Routes />
        <Footer />
      </AppProvider>

      <GlobalStyle />
    </Router>
  );
};

export default App;
